export default {
  tags: "Tags",
  categories: "Categorieën",
  archive: "Archief"
};
